import Vue from 'vue';
import VueRouter from 'vue-router';
import { addClass, removeClass } from '@/utils/dom';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

// Hook adding the bodyClass to the document body, only takes the first matched route
router.beforeEach((to, from, next) => {
  if (from.matched[0]?.meta?.bodyClass) {
    removeClass(document.body, from.matched[0].meta.bodyClass);
  }

  // if (to.matched[0] && to.matched[0].meta && to.matched[0].meta.bodyClass) {
  if (to.matched[0]?.meta?.bodyClass) {
    addClass(document.body, to.matched[0].meta.bodyClass);
  }

  next();
});

router.beforeEach(async (to, from, next) => {
  next();

  // TODO: Replace AppLayout auth handling with requiresAuth and Vue router
  // if (to.matched.some(record => record.meta.requiresAuth)) {
  //   // this route requires auth, check if logged in
  //   // if not, redirect to login page.
  //   if (!auth.loggedIn()) {
  //     next({
  //       path: '/login',
  //       query: { redirect: to.fullPath },
  //     });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

export default router;
